import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IventisTheme } from "@iventis/styles";
import { useTheme } from "@mui/material";

import React from "react";

export const UpdateImage: React.FC<{ className?: string }> = ({ className }) => {
    const theme = useTheme<IventisTheme>();

    return <FontAwesomeIcon color={theme.primaryColors.focus} icon={["fad", "desktop-arrow-down"]} size="10x" className={className} />;
};
